import { render, staticRenderFns } from "./meetingItem.vue?vue&type=template&id=2be61509&scoped=true&"
import script from "./meetingItem.vue?vue&type=script&lang=js&"
export * from "./meetingItem.vue?vue&type=script&lang=js&"
import style0 from "./meetingItem.vue?vue&type=style&index=0&id=2be61509&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be61509",
  null
  
)

export default component.exports